import './RegistrationIndex.css'

import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Form, Modal } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom';
import { t } from 'i18next'
import RegistrationItemList from '../../Components/RegistrationItemList'
import SelectRegistrationCompanyPanel from './Components/SelectRegistrationCompanyPanel';
import { useRegistration } from '../../Providers/RegistrationProvider';
import { useCompanyInfo } from '../../Providers/CompanyInfoProvider';
import LoadingSpinner from '../../Components/Components/LoadingSpinner';
import { checkIfPasswordMeetsConditions, passwordConditionText } from '../../Helpers/CheckPassword';
import InputMask from 'react-input-mask';
import { validateEmail, validatePhoneNoWith48 } from '../../Helpers/ValidatorHelper';
import useCheckLicense from '../../Hooks/useCheckLicense.ts';
import { Licenses } from '../../Data/Licenses.ts';
import { toast } from 'react-toastify';
import { FaRegEye } from 'react-icons/fa6';
import { capitalizeFirstLetter } from '../../Helpers/CustomConverter.jsx';
import { useParams } from '../../Providers/ParamsProvider.jsx';

const RegistrationIndex = () => {
  const { t } = useTranslation()
  const { agreementsVersion } = useParams()
  const [showPanel, setShowPanel] = useState(false)
  const [isClickFind, setIsClickFind] = useState(false)
  const { companyInfoData } = useCompanyInfo()
  const { createNewAccount, registrationInfoVM, isLoadingGetCustomersByTaxId, clearRegistrationInfoVM } = useRegistration()
  const [error, setError] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [handleOnlyLogIn, setHandleOnlyLogIn] = useState(false)
  const navigate = useNavigate()
  const [isPasswordIncorrect, setIsPasswordIncorrect] = useState(false)
  const [isTerms_and_conditions_of_the_trading_portal, setIsTerms_and_conditions_of_the_trading_portal] = useState(false)
  const [isTerms_and_conditions_OWS, setIsTerms_and_conditions_OWS] = useState(false)
  const { checkLicense } = useCheckLicense()
  const [isValidLicense, setIsValidLicense] = useState(checkLicense([Licenses.TgInstalacje]))

  useEffect(() => {
    handleCancelButtonClick()
  }, [])

  const handleCancelButtonClick = () => {
    clearHandlingRegister()
    setShowPanel(false);
    setTmpTaxId('');
    setIsClickFind(false)
    setHandleOnlyLogIn(false)
    clearRegistrationInfoVM()
  }

  const [handlingRegister, setHandlingRegister] = useState({
    taxId: '', regon: '', companyName: '', companyShortName: '', province: '', zipCode: '', city: '', street: '',
    houseNumber: '', localNumber: '', custId: '', name: '', surname: '', email: '', phone: '', country: '', marketingAgree: false, marketingAgreeEmail: false,
    marketingAgreePhone: false, marketingAgreeSms: false, fromGus: false, password: '', reEntryPassword: '', terms_and_conditions_of_the_trading_portal: false,
    terms_and_conditions_OWS: false, hasEhandelAccount: false
  });
  const [tmpTaxId, setTmpTaxId] = useState('');
  const [marketingAgree2, setMarketingAgree2] = useState(false);
  const [registrationCompanies, setRegistrationCompanies] = useState([])

  const handleChangeBool = (e) => {
    const { id, checked } = e.target;

    if (id === "terms_and_conditions_of_the_trading_portal" && !isTerms_and_conditions_of_the_trading_portal) {
      handleDownloadPolicy('terms_and_conditions_of_the_trading_portal')
    }
    else if (id === "terms_and_conditions_OWS" && !isTerms_and_conditions_OWS) {
      handleDownloadPolicy('terms_and_conditions_OWS')
    }

    setHandlingRegister({
      ...handlingRegister,
      [id]: checked
    });

    if (id === "marketingAgree2") {
      handlemarketingAgree2Change(checked);
    }

    if (handlingRegister.marketingAgreeEmail === true || handlingRegister.marketingAgreePhone === true || handlingRegister.marketingAgreeSms === true) {
      setMarketingAgree2(true);
    }

    if (handlingRegister.marketingAgreeEmail === false && handlingRegister.marketingAgreePhone === false && handlingRegister.marketingAgreeSms === false) {
      setMarketingAgree2(false);
    }
    setError('')
  }

  const handleChangeText = (e) => {
    const { id, value } = e.target;
    if (id == 'name' || id == 'street' || id == 'city' || id == 'surname' || id == 'province') {
      const capitalizeValue = capitalizeFirstLetter(value)
      setHandlingRegister({
        ...handlingRegister,
        [id]: capitalizeValue
      });
    } else {
      setHandlingRegister({
        ...handlingRegister,
        [id]: value
      });
    }


    if (id === "taxId") {
      setTmpTaxId(value)
      clearHandlingRegister()
      setIsClickFind(false)
      setHandleOnlyLogIn(false)
    }
    setError('')
  }

  // useEffect(() => {
  //   if (registrationInfoVM && registrationInfoVM.accountExists) {
  //     setIsClickFind(true);
  //     setHandleOnlyLogIn(true)
  //     clearHandlingRegister()
  //   }

  //   else if (registrationInfoVM && registrationInfoVM.possibleCompanies.length === 1) {
  //     setHandlingRegister({
  //       ...handlingRegister, taxId: registrationInfoVM.possibleCompanies[0].taxId, companyName: registrationInfoVM.possibleCompanies[0].companyName,
  //       companyShortName: registrationInfoVM.possibleCompanies[0].companyShortName, street: registrationInfoVM.possibleCompanies[0].street,
  //       province: registrationInfoVM.possibleCompanies[0].province, zipCode: registrationInfoVM.possibleCompanies[0].zipCode, city: registrationInfoVM.possibleCompanies[0].city,
  //       country: registrationInfoVM.possibleCompanies[0].country, houseNumber: registrationInfoVM.possibleCompanies[0].houseNumber,
  //       localNumber: registrationInfoVM.possibleCompanies[0].localNumber, regon: registrationInfoVM.possibleCompanies[0].regon, fromGus: registrationInfoVM.possibleCompanies[0].fromGus,
  //       custId: registrationInfoVM.possibleCompanies[0].custId
  //     })
  //   }
  //   else if (registrationInfoVM && registrationInfoVM.possibleCompanies.length > 1) {
  //     setRegistrationCompanies(registrationInfoVM.possibleCompanies)
  //     setShowPanel(true);
  //   }
  //   else {

  //   }
  // }, [registrationInfoVM])

  useEffect(() => {
    if (registrationInfoVM && registrationInfoVM.possibleCompanies.length === 1 && registrationInfoVM.possibleCompanies[0].hasEhandelAccount) {
      setIsClickFind(true);
      setHandleOnlyLogIn(true)
      clearHandlingRegister()
    }

    else if (registrationInfoVM && registrationInfoVM.possibleCompanies.length === 1) {
      setHandlingRegister({
        ...handlingRegister, taxId: registrationInfoVM.possibleCompanies[0].taxId, companyName: registrationInfoVM.possibleCompanies[0].companyName,
        companyShortName: registrationInfoVM.possibleCompanies[0].companyShortName, street: registrationInfoVM.possibleCompanies[0].street,
        province: registrationInfoVM.possibleCompanies[0].province, zipCode: registrationInfoVM.possibleCompanies[0].zipCode, city: registrationInfoVM.possibleCompanies[0].city,
        country: registrationInfoVM.possibleCompanies[0].country, houseNumber: registrationInfoVM.possibleCompanies[0].houseNumber,
        localNumber: registrationInfoVM.possibleCompanies[0].localNumber, regon: registrationInfoVM.possibleCompanies[0].regon, fromGus: registrationInfoVM.possibleCompanies[0].fromGus,
        custId: registrationInfoVM.possibleCompanies[0].custId
      })
    }
    else if (registrationInfoVM && registrationInfoVM.possibleCompanies.length > 1) {
      setRegistrationCompanies(registrationInfoVM.possibleCompanies)
      setShowPanel(true);
    }
    else {

    }
  }, [registrationInfoVM])

  const handlemarketingAgree2Change = (checked) => {
    if (!checked) {
      setHandlingRegister({ ...handlingRegister, marketingAgreeEmail: false, marketingAgreePhone: false, marketingAgreeSms: false });
    } else {
      setHandlingRegister({ ...handlingRegister, marketingAgreeEmail: true, marketingAgreePhone: true, marketingAgreeSms: true })
    }
  };

  const clearHandlingRegister = () => {
    setHandlingRegister({
      taxId: '', regon: '', companyName: '', companyShortName: '', province: '', zipCode: '', city: '', street: '', houseNumber: '', localNumber: '', custId: '',
      name: '', surname: '', email: '', phone: '', country: '', marketingAgree: false, marketingAgreeEmail: false, marketingAgreePhone: false,
      marketingAgreeSms: false, fromGus: false, password: '', reEntryPassword: '', terms_and_conditions_of_the_trading_portal: false, terms_and_conditions_OWS: false,
      hasEhandelAccount: false
    })
  }

  const handleSelectRegistrationCompany = (row) => {
    if (row.hasEhandelAccount) {
      setIsClickFind(true);
      setHandleOnlyLogIn(true)
      clearHandlingRegister()
    }
    setHandlingRegister({
      ...handlingRegister, taxId: row.taxId, companyName: row.companyName, companyShortName: row.companyShortName, street: row.street, province:
        row.province, zipCode: row.zipCode, city: row.city, country: row.country, houseNumber: row.houseNumber, localNumber: row.localNumber,
      regon: row.regon, fromGus: row.fromGus, custId: row.custId, hasEhandelAccount: row.hasEhandelAccount
    })
    setRegistrationCompanies([])
    setShowPanel(false);
  }

  const validationResults = checkIfPasswordMeetsConditions(handlingRegister.password);
  const missingRequirements = Object.values(validationResults)
    .filter((data) => data && !data.valid)
    .map((data) => data.description)
    .join(", ");


  const signUp = async () => {
    if (handleOnlyLogIn) {
      return
    }

    if (!handlingRegister.email || !validateEmail(handlingRegister.email)) {
      setError("Podaj prawidłowy adres e-mail!")
      return;
    }
    else if (!handlingRegister.name) {
      setError("Podaj imię!")
      return;
    } else if (!handlingRegister.taxId) {
      setError("Podaj NIP!")
      return;
    } else if (!!!handlingRegister.surname) {
      setError("Podaj nazwisko!")
      return;
    } else if (!handlingRegister.street) {
      setError("Podaj ulicę!")
      return;
    } else if (!handlingRegister.zipCode) {
      setError("Podaj kod pocztowy!")
      return;
    } else if (!handlingRegister.city) {
      setError("Podaj miejscowość!")
      return;
    } else if (!handlingRegister.email) {
      setError("Podaj adres e-mail!")
      return;
    } else if (!handlingRegister.phone || !validatePhoneNoWith48(handlingRegister.phone)) {
      setError("Niepoprawny numer telefonu!")
      return;
    }
    else if (handlingRegister.phone === '') {
      setError("Podaj numer telefonu!")
      return;
    }
    else if (missingRequirements.length > 0) {
      setError(`Hasło nie spełnia wymagań!`)
      setIsPasswordIncorrect(true)
      return;
    }
    else if (handlingRegister.reEntryPassword !== handlingRegister.password) {
      setError(`Wpisane hasła nie są zgodne!`)
      return
    }
    else if (!handlingRegister.marketingAgree) {
      setError("Prosze zaznaczyć wymagane zgody!")
      return
    }

    if (isValidLicense) {
      if (!handlingRegister.terms_and_conditions_of_the_trading_portal || !handlingRegister.terms_and_conditions_OWS) {
        setError("Prosze zaznaczyć wymagane zgody!")
        return
      }
    }


    var data = {
      name: handlingRegister.name,
      surname: handlingRegister.surname,
      email: handlingRegister.email,
      password: handlingRegister.password,
      phone: handlingRegister.phone,
      taxId: handlingRegister.taxId,
      marketingAgree: handlingRegister.marketingAgree,
      marketingAgreeEmail: handlingRegister.marketingAgreeEmail,
      marketingAgreePhone: handlingRegister.marketingAgreePhone,
      marketingAgreeSms: handlingRegister.marketingAgreeSms,
      fromGus: handlingRegister.fromGus,
      custId: handlingRegister.custId,
      companyInfo: {
        taxId: handlingRegister.taxId,
        companyName: handlingRegister.companyName,
        companyShortName: handlingRegister.companyShortName,
        province: handlingRegister.province,
        zipCode: handlingRegister.zipCode,
        city: handlingRegister.city,
        country: handlingRegister.country,
        houseNumber: handlingRegister.houseNumber,
        localNumber: handlingRegister.localNumber,
        regon: handlingRegister.regon,
        fromGus: handlingRegister.fromGus,
        custId: handlingRegister.custId,
        street: handlingRegister.street
      },
      acceptedAgreementsVersion: agreementsVersion
    }

    setIsLoading(true)
    const result = await createNewAccount(data)
    setIsLoading(false)
    if (result && result.success) {
      handleCancelButtonClick()
      navigate('/AccountCreated')
    }
    else {
      if (result && result.error) {
        toast.error(result.error)
        setError(result.error)
      }
      else {
        toast.error('Błąd podczas rejestracji!')
        setError("Błąd podczas rejestracji!")
      }
    }
  }

  const handleLogIn = () => {
    handleCancelButtonClick()
    navigate('/login')

  }

  const handleDownloadPolicy = (policy) => {
    let consentLink = ''
    switch (policy) {
      case "terms_and_conditions_of_the_trading_portal":
        setIsTerms_and_conditions_of_the_trading_portal(true)
        consentLink = '/Statements/TG/Regulamin Portalu Transakcyjnego E-Handel.pdf'
        window.open(consentLink, '_blank')

        break;
      case "terms_and_conditions_OWS":
        setIsTerms_and_conditions_OWS(true)
        consentLink = '/Statements/TG/OWS.pdf'
        window.open(consentLink, '_blank')

        break;
    }
  }

  const changeVisibilitytoHidden = isLoadingGetCustomersByTaxId ? 'hidden' : ''
  const registrationButtonStyle = handleOnlyLogIn ? 'btn-app-disabled' : ''
  const errorStyle = error ? '' : 'collapse'

  return (
    <div className='container-fluid-with-paddings mt-5 mb-5'>
      <div className='row'>
        <div className='col-12 col-lg-8 mt-2'>
          <div className='justify-content-center'>
            <div className='main-container-holder p-5'>
              {isLoading ? (<LoadingSpinner />) : (<>
                <PersonalDataPanel
                  tmpTaxId={tmpTaxId}
                  handleChangeText={handleChangeText}
                  handlingRegister={handlingRegister}
                  isClickFind={isClickFind}
                  showPanel={showPanel}
                  handleSelectRegistrationCompany={handleSelectRegistrationCompany}
                  handleCancelButtonClick={handleCancelButtonClick}
                  registrationCompanies={registrationCompanies}
                  isLoadingGetCustomersByTaxId={isLoadingGetCustomersByTaxId}
                  handleOnlyLogIn={handleOnlyLogIn}
                  isPasswordIncorrect={isPasswordIncorrect}
                />
                <MarketingAgree
                  handleChange={handleChangeBool}
                  companyInfoData={companyInfoData}
                  handlingRegister={handlingRegister}
                  changeVisibilitytoHidden={changeVisibilitytoHidden}
                  handleOnlyLogIn={handleOnlyLogIn}
                  handleDownloadPolicy={handleDownloadPolicy}
                  isValidLicense={isValidLicense}
                />
                <div className="row d-flex flex-column">
                  <span>
                    <span className='error-text-color'>*</span> Pola wymagane
                  </span>
                  <b className={`row error-text-color justify-content-center mb-4 ${errorStyle}`}>{error}</b>
                </div>
                <div className={`${changeVisibilitytoHidden} row cont mt-4`}>
                  <div className='col-auto'>
                    <Button className={`${registrationButtonStyle} btn-app-secondary`} size='md' onClick={signUp}>
                      {t('signUp')}
                    </Button>
                  </div>
                  <div className='col-auto ms-auto'>
                    <Button className='btn-app-secondary' size='md' onClick={handleLogIn}>
                      &larr;&nbsp;&nbsp;
                      {t('login_button_top_bar')}
                    </Button>
                  </div>
                </div>
              </>)}
            </div>
          </div>
        </div>
        <div className='col offset-1 mt-4'>
          <RegistrationItemList />
        </div>

      </div>
    </div>
  )
}

const PersonalDataPanel = ({ tmpTaxId, handleChangeText, showPanel, isClickFind, handleCancelButtonClick, handleSelectRegistrationCompany, handlingRegister, registrationCompanies,
  isLoadingGetCustomersByTaxId, handleOnlyLogIn, isPasswordIncorrect }) => {

  const { getCustomersByTaxId, errorGetCustomersByTaxId } = useRegistration()

  const handleKeyPress = (event) => {
    if (event && event.key === "Enter") {
      getCustomersByTaxId(tmpTaxId)
    }
  }

  return <>
    <Modal size='xl' show={showPanel} onHide={handleCancelButtonClick} centered>
      <Modal.Header closeButton>
        <Modal.Title>Wybierz dane dla konta</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <SelectRegistrationCompanyPanel registrationCompanies={registrationCompanies} handleSelectRegistrationCompany={handleSelectRegistrationCompany} />
      </Modal.Body>
    </Modal>
    <div className="row cont profile-details-info-registration">
      <div className='col'>
        <div className='panel-header-title'>{t("fill_out_registration_form")}   </div>
        <div className="row data-container-registration mt-3 mb-4">
          <div className="col-12 col-md-6  d-flex">
            <Form.Control id='taxId' type='text' value={tmpTaxId} placeholder={t("nip_table_header_contractor_page")} onChange={handleChangeText} onKeyDown={handleKeyPress} required />
            <span className='error-text-color'>&nbsp;*</span>
          </div>

          {(isClickFind) ? <div className="col-12 col-md-6 mt-2 mt-md-0 text-lineheight-small" style={{ fontSize: 'small' }}>
            <Form.Label id='taxIdInfo' type='text' readOnly>{t("taxIdInfo")}</Form.Label><br />
            <a href='/login'>{t('login_button_top_bar')}</a>
          </div> : <div className='col-12 col-md-6 mt-2 mt-md-0'>
            <button className='btn-app-secondary' style={{ paddingTop: "8px", paddingBottom: "8px" }} onClick={() => getCustomersByTaxId(tmpTaxId)} >
              {t('find_by_tax_id')}
            </button>
          </div>
          }
        </div>
        {errorGetCustomersByTaxId.length > 0 && <div className="col-12 error-text-color justify-content-center mb-1" style={{ marginTop: "-20px" }}>{errorGetCustomersByTaxId}</div>}
        {isLoadingGetCustomersByTaxId ? (<LoadingSpinner />) :
          (<MainSection
            handleOnlyLogIn={handleOnlyLogIn}
            handlingRegister={handlingRegister}
            handleChangeText={handleChangeText}
            isPasswordIncorrect={isPasswordIncorrect}
          />)}
      </div>

    </div >
  </>
}

const MainSection = ({ handleOnlyLogIn, handlingRegister, handleChangeText, isPasswordIncorrect }) => {
  const [showPassword, setShowPassword] = useState(false)
  const [showReEntryPassword, setShowReEntryPassword] = useState(false)

  let passwordConditionTextStyle = isPasswordIncorrect ? 'error-text-color' : ''

  if (handleOnlyLogIn) {
    return null
  }
  else {
    let fullAddress = `${handlingRegister.street} ${!handlingRegister.localNumber ? handlingRegister.houseNumber : handlingRegister.houseNumber + '/' + handlingRegister.localNumber}`
    let fullAddressValidated = fullAddress && fullAddress.trim() !== '' ? fullAddress : ''
    return (
      <>
        <div className="row data-container-registration">
          <div className="col">
            <Form.Control id='companyName' type='text' value={handlingRegister.companyName} placeholder={t("company_Name")} onChange={handleChangeText} readOnly />
          </div>
          <div className="col-12 col-md mt-2 mt-md-0">
            <Form.Control id='street' type='text' value={fullAddressValidated} placeholder={t("street")} onChange={handleChangeText} readOnly />
          </div>
        </div>
        <div className="row data-container-registration mb-4">
          <div className="col-12 col-md">
            <Form.Control id='province' type='text' placeholder={t("region")} value={handlingRegister.province} onChange={handleChangeText} readOnly />
          </div>
          <div className="col-6 col-md-3 mt-2 mt-md-0">
            <Form.Control id='zipCode' type='text' placeholder={t("zipCode")} value={handlingRegister.zipCode} onChange={handleChangeText} readOnly />
          </div>
          <div className="col-6 col-md-3 mt-2 mt-md-0">
            <Form.Control id='city' type='text' placeholder={t("city")} value={handlingRegister.city} onChange={handleChangeText} readOnly />
          </div>
        </div>
        <div className="row data-container-registration">
          <div className="col-12 col-md d-flex">
            <Form.Control id='name' type='text' placeholder={t("name")} value={handlingRegister.name} onChange={handleChangeText} required autocomplete="off" />
            <span className='error-text-color'>&nbsp;*</span>
          </div>
          <div className="col-12 col-md-6 mt-2 mt-md-0 d-flex">
            <Form.Control id='surname' type='text' placeholder={t("surname")} value={handlingRegister.surname} onChange={handleChangeText} required autocomplete="off" />
            <span className='error-text-color'>&nbsp;*</span>
          </div>
        </div>
        <div className="row data-container-registration">
          <div className="col-12 col-md-6 d-flex">
            <Form.Control id='email' name='login' type='text' placeholder='E-mail' onChange={handleChangeText} value={handlingRegister.email} required autocomplete="username" />
            <span className='error-text-color'>&nbsp;*</span>
          </div>
          <div className="col-12 col-md mt-2 mt-md-0 d-flex">
            <InputMask
              mask="+48 999 999 999"
              value={handlingRegister.phone}
              onChange={handleChangeText}
            >
              {(inputProps) => (
                <Form.Control
                  {...inputProps}
                  id="phone"
                  type="text"
                  placeholder={t("phone")}
                  required
                  autocomplete="off"
                />
              )}
            </InputMask>
            <span className='error-text-color'>&nbsp;*</span>
          </div>
        </div>
        <div className="row data-container-registration">
          <div className="col d-flex align-items-center">
            <Form.Control
              id='password'
              type={showPassword ? 'text' : 'password'}
              placeholder={t("password")}
              onChange={handleChangeText}
              value={handlingRegister.password}
              required
              autocomplete="off"
            />
            <FaRegEye
              color='var(--primary)'
              size={20} className='element-pointer ms-2 me-2'
              onMouseDown={() => setShowPassword(true)}
              onMouseUp={() => setShowPassword(false)}
              onMouseLeave={() => setShowPassword(false)}
              onTouchStart={() => setShowPassword(true)}
              onTouchEnd={() => setShowPassword(false)}
            />
            <span className='error-text-color align-self-start'>&nbsp;*</span>
          </div>
        </div>
        <div className="row data-container-registration">
          <div className="col d-flex align-items-center">
            <Form.Control
              id='reEntryPassword'
              type={showReEntryPassword ? 'text' : 'password'}
              placeholder={t("re-entry-new-password")}
              onChange={handleChangeText}
              value={handlingRegister.reEntryPassword}
              required
              autocomplete="off"
            />
            <FaRegEye
              color='var(--primary)'
              size={20} className='element-pointer ms-2 me-2'
              onMouseDown={() => setShowReEntryPassword(true)}
              onMouseUp={() => setShowReEntryPassword(false)}
              onMouseLeave={() => setShowReEntryPassword(false)}
              onTouchStart={() => setShowReEntryPassword(true)}
              onTouchEnd={() => setShowReEntryPassword(false)}
            />
            <span className='error-text-color align-self-start'>&nbsp;*</span>
          </div>
        </div>
        <div className="row mt-2 mb-2">
          <span className={passwordConditionTextStyle}>{passwordConditionText}</span>
        </div>
      </>
    )
  }
}

const MarketingAgree = ({ handleChange, companyInfoData, handlingRegister, changeVisibilitytoHidden, handleOnlyLogIn, handleDownloadPolicy, isValidLicense }) => {
  if (handleOnlyLogIn) {
    return null
  }
  return <>
    <div className={`${changeVisibilitytoHidden}`}>
      <div className='row justify-content-center'>
        <div className='justify-content-center'>
          {(isValidLicense) ? <> <div className="consent-checkbox">
            <input type="checkbox" id="terms_and_conditions_of_the_trading_portal" className="checkbox-custom"
              checked={handlingRegister.terms_and_conditions_of_the_trading_portal}
              onChange={handleChange} />
            <label>
              {t("terms_and_conditions_of_the_trading_portal")}
              <span className='error-text-color'> *</span>
            </label>
            <div className="row d-flex ms-2">
              <label className='app-link m-0 p-0' onClick={() => handleDownloadPolicy('terms_and_conditions_of_the_trading_portal')}>
                {t("download")}
              </label>
            </div>
          </div>
            <div className="consent-checkbox">
              <input type="checkbox" id="terms_and_conditions_OWS" className="checkbox-custom"
                checked={handlingRegister.terms_and_conditions_OWS}
                onChange={handleChange} />
              <label>
                {t("terms_and_conditions_OWS")}
                <span className='error-text-color'> *</span>
              </label>
              <div className="row d-flex ms-2">
                <label className='app-link m-0 p-0' onClick={() => handleDownloadPolicy('terms_and_conditions_OWS')}>
                  {t("download")}
                </label>
              </div>
            </div>
          </> : <></>
          }
          <div className="consent-checkbox">
            <input type="checkbox" id="marketingAgree" className="checkbox-custom"
              checked={handlingRegister.marketingAgree}
              onChange={handleChange} />
            <label htmlFor="consent-marketing">
              {t("consent_marketing1")}{companyInfoData.name}{t("consent_marketing2")}
              <span className='error-text-color'> *</span>
            </label>
          </div>
          <div className="consent-checkbox">
            <input type="checkbox" id="marketingAgree2" className="checkbox-custom"
              onChange={handleChange} />
            <label htmlFor="consent-info">
              {t("consent_info1")}{companyInfoData.name}{t("consent_info2")}
            </label>
          </div>
          <div className="checkbox-options">
            <div className="option">
              <input type="checkbox" className="checkbox-custom" id="marketingAgreeEmail"
                checked={handlingRegister.marketingAgreeEmail}
                onChange={handleChange} />
              <label htmlFor="email">Email</label>
            </div>
            <div className="option">
              <input type="checkbox" className="checkbox-custom" id="marketingAgreePhone"
                checked={handlingRegister.marketingAgreePhone}
                onChange={handleChange} />
              <label htmlFor="phone">{t("phone")}</label>
            </div>
            <div className="option">
              <input type="checkbox" className="checkbox-custom" id="marketingAgreeSms"
                checked={handlingRegister.marketingAgreeSms}
                onChange={handleChange} />
              <label htmlFor="sms">Sms</label>
            </div>
          </div>
        </div >
      </div >
    </div >
  </>

}



export default RegistrationIndex